<template>
  <div class="detail">
    <div class="poster" id="poster">
      <!-- <div class="poster" id="poster" :style="{background:'url(' + detail.poster + ') no-repeat',height:posterHeight+'px'}"> -->
      <img
        :src="detail.poster + '@390h_750w_1e_1c'"
        :style="{ height: posterHeight + 'px' }"
        alt=""
      />
    </div>

    <div class="detail-info">
      <div class="title">{{ detail.title }}</div>
      <div class="title_little">
        <van-rate
          v-model="rateNum"
          :size="14"
          color="#ee0a24"
          void-icon="star"
          void-color="#eee"
        />

        <div class="sale_count" v-if="detail.saleCount">
          销量：{{ detail.saleCount }}件
        </div>
      </div>

      <div class="big-info">
        <div class="item">
          <div class="label">保险公司：</div>
          <div class="item-info">
            <div class="company">本保险由{{ detail.insuranceCompany }}承保</div>
          </div>
        </div>

        <div class="item" v-if="detail.summarys">
          <div class="label">{{ detail.summarys[0][0] }}:</div>
          <div class="item-info">
            <div class="company">{{ detail.summarys[0][1] }}</div>
          </div>
        </div>

        <div class="item" v-if="detail.summarys">
          <div class="label">{{ detail.summarys[1][0] }}:</div>
          <div class="item-info">
            <div class="company">{{ detail.summarys[1][1] }}</div>
          </div>
        </div>

        <!-- <van-tabs v-model="active" swipeable id="plans-tab">
          <van-tab v-for="(item,index) in detail.plans" :title="item.name" :key="index">
            内容 {{ index }}
          </van-tab>
        </van-tabs> -->

        <!-- <div class="item">
          <div class="label">保障计划：</div>
          <div class="item-info">
            <van-button class="item-btn" type="default" :class="selectModel.selectPlans==index?'option-cur':''" v-for="(item,index) in detail.plans" :key="index" @click="changeselectPlans(index)" >{{item.name}}</van-button>
          </div>
        </div> -->

        <!-- <div class="item">
          <div class="label">保障期限：</div>
          <div class="item-info">
            <van-button class="item-btn" type="default" :class="selectModel.selectTime==index?'option-cur':''" v-for="(item,index) in detail.plans[selectPlans].cycle" :key="index" @click="changeselectTime(index)" >{{item.start}}-{{item.end}}天</van-button>
          </div>
        </div> -->

        <!-- <div class="item">
          <div class="label">承保年龄：</div>
          <div class="item-info">
            <van-button class="item-btn" type="default" :class="selectModel.selectAge==index?'option-cur':''" v-for="(item,index) in setAges" :key="index" @click="changeselectAge(index)" >{{item.start}}-{{item.end}}周岁</van-button>
          </div>
        </div> -->

        <!-- <div class="item">
          <div class="label">保障内容：</div>
          <div class="summary-info">
            <div class="item" v-for="(item,index) in summarys" :key="index">
              <div class="title">{{item.name}}</div>
              <div class="price">{{item.price}}元</div>
            </div>
          </div>
        </div> -->

        <!-- <div class="item">
          <div class="label">产品价格：</div>
          <div class="item-info">
            <span class="fuhao">¥</span><span class="price">{{price}}</span>
          </div>
        </div> -->
      </div>
    </div>

    <div class="bar10px"></div>

    <div class="select-plan1">
      <van-tabs @click="changeselectPlans">
        <van-tab v-for="(item, index) in detail.plans" :key="index">
          <template #title>
            <div class="title-box">
              <div class="price">
                <span class="fuhao">¥</span> {{ item.cycle[0].price }}
                <span class="text">起</span>
              </div>
              <div class="title">{{ item.name }}</div>
            </div>
          </template>
          <div class="summary-info">
            <div class="item" v-for="(item1, index1) in summarys" :key="index1">
              <div class="title" v-if="detail.insuranceCompanyId == 9 && (item1.name1 || item1.nameInfo)">
                {{ item1.name1 }} <span style="font-weight: bold;">{{ item1.nameInfo }}</span>
              </div>
              <div class="title" v-else>
                {{ detail.plans[0].summarys[index1].name }}
              </div>
              <div class="price">{{ item1.price | countFilter }}元</div>
            </div>
          </div>
        </van-tab>
        <img class="jiantou" v-if="showTip" src="./assets/images/jiantou.gif"  alt="" />
      </van-tabs>
    </div>

    <div class="bar10px"></div>

    <div class="detail-tab">
      <van-tabs id="detail-tabs" v-model="tabActive" swipeable sticky>
        <!-- <van-tab title="产品详情">
          产品详情
        </van-tab> -->
        <van-tab title="投保须知">
          <div id="content2" v-html="detail.content"></div>
        </van-tab>
        <van-tab title="常见问题">
          <div id="content3" v-html="detail.question"></div>
        </van-tab>
        <van-tab title="理赔指引">
          <div id="content4">
            <div class="img-box">
              <img src="./assets/images/1.png" alt="" />
              <img src="./assets/images/2.png" alt="" />
              <img src="./assets/images/3.png" alt="" />
              <img src="./assets/images/4.png" alt="" />
            </div>
            <div class="direct-box">
              <p style="font-size: 13px; color: #333; font-weight: 500">
                涉及身故责任、第三者责任请务必及时联系保险公司进行二次报案。
              </p>
              <p>
                出险（意外）需要就医时，请及时到二级及以上公立医院就医（具体医院要求请以保险条款约定为准）；
              </p>
              <p>
                门诊治疗请留存完整的门诊病历、费用清单、检查报告单（如CT）、发票原件等资料；
              </p>
              <p>
                住院治疗请留存医院出具的盖章住院病历（包括住院病案首页、出入院记录、诊断证明书、检查报告单、手术记录、医嘱单、体温单）和完整费用汇总清单；
              </p>
              <p>需提供发票收据联原件或发票复印件盖章+医保结算单原件；</p>
              <p>
                伤残理赔需在保险公司认可的伤残鉴定机构，按条款约定的伤残评定标准进行，具体请参考保险条款及保单约定；
              </p>
              <p>
                交通工具意外伤害需保留相关部门（交警、医院、残疾鉴定机构、公安局等）的事故证明。
              </p>
              <p></p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <div class="foot-btn" v-if="!(id == 1751513009891 && $route.query.c == 'zzb')">
      <div class="left">
        <a href="tel://4008-933-988">
          <img src="./assets/images/tel.png" alt="" />
        </a>
      </div>
      <div class="price">¥{{ price }}起</div>
      <div class="right" v-if="detail.isClose == 2" style="background: #999">
        暂停购买
      </div>
      <div class="right" @click="gotoSign" v-else>立即购买</div>
    </div>

    <van-popup v-model="choseInfoFlag" position="bottom" :round="true">
      <div class="calcurePrice">
        <div class="title">保费计算</div>
        <div class="close" @click="choseInfoFlag = false">关闭</div>
        <div class="plan_start">
          <van-field
            label="保险起期:"
            value="请选择保险开始时间"
            input-align="right"
            v-model="startTime"
            @click.native="datetimePicker = true"
            readonly
            right-icon="calender-o"
          />
        </div>
        <div class="item">
          <div class="label">保障计划：</div>
          <div class="item-info" v-if="detail.plans">
            <van-button
              class="item-btn"
              type="default"
              :class="selectModel.selectPlans == index ? 'option-cur' : ''"
              v-for="(item, index) in detail.plans"
              :key="index"
              @click="changeselectPlans(index)"
              >{{ item.name }}</van-button
            >
          </div>
        </div>
        <div class="item" v-if="detail.plans">
          <div class="label">保障期限：</div>
          <div class="item-info">
            <van-button class="item-btn" type="default" v-for="(item, index) in setTimes" :key="index" v-if="index < 5" :class="selectModel.selectTime == index ? 'option-cur' : ''"  @click="changeselectTime(index)">
              <span v-if="item.start != item.end && item.end != 365" >{{ item.start }}-{{ item.end }}天</span>
              <span v-if="item.start == item.end && item.end != 365" >{{ item.start }}天</span>
              <span v-if="item.end == 365 || item.end == 366">1年</span>
              <!-- <span v-if="detail.id == '78' ">
                <span v-if="(item.end == 365 || item.end == 366) && item.start == 1 && detail.id == '78' ">1年(无单次出行天数限制)</span>
                    <span v-if="(item.end == 365 || item.end == 366) && item.start != 1 && detail.id == '78' ">1年(单次183天为限)</span>
                </span>
                <span v-else>
                  <span v-if="item.end == 365 || item.end == 366">1年</span>
                </span> -->
            </van-button>
            <van-button class="item-btn" type="default" :class="selectModel.selectTime > 4 ? 'option-cur' : ''" @click="selectPicker = true"  v-if="muchDays == true">
               <span>更多天数</span>
            </van-button>
          </div>
        </div>
        <div class="item">
          <div class="label">承保年龄：</div>
          <div class="item-info">
            <van-button
              class="item-btn"
              type="default"
              :class="selectModel.selectAge == index ? 'option-cur' : ''"
              @click="changeselectAge(index)"
              v-for="(item, index) in setAges"
              :key="index"
            >
              <span>{{ item.start }}-{{ item.end }}周岁</span>
            </van-button>
          </div>
        </div>
        <div class="foot-btn">
          <div class="left">
            <a>
              <img src="./assets/images/tel.png" alt="" />
            </a>
          </div>
          <div class="price">¥{{ price }}</div>
          <div class="right" @click="gotoSign">立即购买</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="selectPicker" position="bottom">
      <van-picker 
        :columns="moreDate" 
        title="更多天数" 
        show-toolbar 
        keyName="date" 
        :value="selectModel.selectTime < 5 ? 0 : selectModel.selectTime - 5" 
        @cancel="selectPicker = false"
        @confirm="selectMoreDate" />
    </van-popup>
    
    <van-popup v-model="datetimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="datetimePicker = false"
        :min-date="minDate"
        :max-date="this.maxDate"/>
    </van-popup>
    
    <!-- <van-calendar :min-date="minDate" :max-date="this.maxDate" v-model="datetimePicker" @confirm="confirmDate" /> -->

  </div>
</template>

<script>
import { Rate, Button, Tab, Tabs, Popup, Field, DatetimePicker ,Picker, Calendar } from "vant";
import moment from "moment";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
import storejs from "store";

export default {
  name: "Detail",
  components: {
    [Rate.name]: Rate,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]:Picker,
    [Calendar.name]:Calendar,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      id: this.$route.query.id,
      posterHeight: 250,
      detail: {},
      rateNum: 5,
      selectPlans: 0,
      selectCycle: 0,
      selectTime: 0,
      selectAge: 0,
      price: 0,
      selectModel: {
        selectPlans: 0,
        selectCycle: 0,
        selectTime: 0,
        selectAge: 0,
      },
      muchDays:false,
      summarys: [],
      setAges: [],
      setTimes: [],
      sectionArr: [
        {
          id: 0,
          content: "",
          name: "产品详情",
        },
        {
          id: 1,
          content: "",
          name: "投保须知",
        },
        {
          id: 2,
          content: "",
          name: "常见问题",
        },
      ],
      tabActive: "",
      choseInfoFlag: false,
      datetimePicker: false,
      minDate: new Date(),
      // maxDate: new Date(2023, 11, 31),
      currentDate: new Date(),
      startTime: "请选择保险起保时间",
      showTip: false,
      insuranceCompanyLogo: "",
      selectPicker:false
    };
  },
  mounted() {
    this.initStyle();
    if(this.$route.query.e){
      this.verifyLinkValid(() => {
        this.init()
      })
    }else{
      this.init();
    }    
    console.log("this.$route.query.id", this.$route.query.id);
  },
  computed: {
    // 投保时间限制
    maxDate() {
      if(this.detail.id == 36){
        let curDate = new Date().getTime();
        console.log("curdaate", curDate);
        let one = (365 * 2) * 24 * 3600 * 1000;
        let oneYear = curDate + one;
        console.log("oneYear", oneYear);
        return new Date(oneYear);
      }else{
        let curDate = new Date().getTime();
        console.log("curdaate", curDate);
        let one = 365 * 24 * 3600 * 1000;
        let oneYear = curDate + one;
        console.log("oneYear", oneYear);
        return new Date(oneYear);
      }
    },
    moreDate() {
				if (this.setTimes && this.setTimes.length) {
					let newArr = JSON.parse(JSON.stringify(this.setTimes.splice(5, this.setTimes.length - 1)));
          let newArraway = []
					newArr.forEach(item => {
						if (item.start != item.end && (item.end != 365)) {
							item.date = `${item.start}-${item.end}天`
						} else if (item.start == item.end && (item.end != 365)) {
							item.date = `${item.start}天`
						} else if (item.end == 365 || item.end == 366) {
							item.date = `1年`
						}
            newArraway.push(item.date)
					})
					return newArraway;
				}
			}
  },
  watch: {
    selectModel: {
      handler(val) {
        console.log(val);
        if (!!this.detail.plans.length) {
          let start = this.detail.plans[this.selectModel.selectPlans].cycle[this.selectModel.selectTime].start;
          let end = this.detail.plans[this.selectModel.selectPlans].cycle[this.selectModel.selectTime].end;
          let startAge = this.detail.plans[this.selectModel.selectPlans].cycle[this.selectModel.selectTime].startAge;
          let endAge = this.detail.plans[this.selectModel.selectPlans].cycle[this.selectModel.selectTime].endAge;
          let arr = [];

          this.detail.plans[this.selectModel.selectPlans].cycle.forEach(
            (el) => {
              arr.push({
                start: el.startAge,
                end: el.endAge,
              });
              if (el.start == start) {
                if (this.choseInfoFlag) {
                  this.price = el.price;
                } else {
                  this.price =
                    this.detail.plans[
                      this.selectModel.selectPlans
                    ].cycle[0].price;
                }
              }
            }
          );
          for (let i = arr.length; i > 0; i--) {
            for (let j = i - 1; j > -1; j--) {
              if (JSON.stringify(arr[i]) === JSON.stringify(arr[j])) {
                console.log(arr[j]);
                arr.splice(j, 1);
              }
            }
          }
          this.setAges = arr;
          let timeArr = [];
          this.detail.plans[this.selectModel.selectPlans].cycle.forEach(
            (el) => {
              // setTimes
              // console.log("el",el)
              // console.log(el.startAge , arr[this.selectModel.selectAge].start)
              // console.log(el.endAge , arr[this.selectModel.selectAge].end)
              if (
                el.startAge == arr[this.selectModel.selectAge].start &&
                el.endAge == arr[this.selectModel.selectAge].end
              ) {
                // console.log("el",el)
                timeArr.push(el);
              }
            }
          );
          this.setTimes = timeArr;
          this.price = this.setTimes[this.selectModel.selectTime].price;
        }
      },
      deep: true,
    },
  },
  methods: {
    async verifyLinkValid(callback){
      let res = await this.$http.post("api/accountLogin/linkVerification", {parameter: this.$route.query.e}); 
      if(res.code == 0){
        if(callback && typeof callback == 'function'){
          callback();
        }
      }else{
        if(res.msg){
          this.$toast(res.msg);
        }
      }
    },
    initStyle() {
      let width = window.innerWidth;
      let height = width;
      this.posterHeight = height * 0.52;
      this.minDate = new Date();
      console.log(new Date());
    },
    confirmDate(value) {
      console.log(value.getTime());
      this.startTime = moment(value.getTime()).format("YYYY-MM-DD");
      this.datetimePicker = false;
    },
    gotoSign() {
      if (this.choseInfoFlag) {
        let startTime = moment(this.startTime).valueOf();
        console.log("startTime",startTime)
        console.log(moment(this.startTime).valueOf());
        if (!(startTime > 0)) {
          this.$toast.fail("请选择保险起保时间");
          return;
        }
        if(location.href.indexOf("applicant_i_employee_number") != -1){
          let url = window.location.href;
          let i = url.lastIndexOf('\=');
          let employeeNo = url.substring(i + 1, url.length);
          console.log('employeeNo', employeeNo)     // channel=HTML5

          this.$router.push({
          name: "Sign",
          query: {
            id: this.detail.id,
            // title:this.detail.title,
            startTime: this.startTime,
            plan: this.selectModel.selectPlans,
            startAge: this.setAges[this.selectModel.selectAge].start,
            endAge: this.setAges[this.selectModel.selectAge].end,
            date: this.selectModel.selectTime,
            c: this.$route.query.c,
            t: new Date().getTime(),
            employeeNo:employeeNo
          },
        });
        }else{
          this.$router.push({
          name: "Sign",
          query: {
            id: this.detail.id,
            // title:this.detail.title,
            startTime: this.startTime,
            plan: this.selectModel.selectPlans,
            startAge: this.setAges[this.selectModel.selectAge].start,
            endAge: this.setAges[this.selectModel.selectAge].end,
            date: this.selectModel.selectTime,
            c: this.$route.query.c,
            t: new Date().getTime(),
          },
        });
        }
        // this.$router.push({
        //   name: "Sign",
        //   query: {
        //     id: this.detail.id,
        //     // title:this.detail.title,
        //     startTime: this.startTime,
        //     plan: this.selectModel.selectPlans,
        //     startAge: this.setAges[this.selectModel.selectAge].start,
        //     endAge: this.setAges[this.selectModel.selectAge].end,
        //     date: this.selectModel.selectTime,
        //     c: this.$route.query.c,
        //     t: new Date().getTime(),
        //   },
        // });
        // location.href = '/sign?id=' + this.$route.query.id + '&startTime=' + this.startTime + '&plan='
        // + this.selectModel.selectPlans + '&date=' + this.selectModel.selectTime +'&c=' + this.$route.query.c
      } else {
        this.choseInfoFlag = true;
      }
    },
    async init() {
      await this.getDetail();
      if (location.href.indexOf("http://localhost") != -1) {
      } else if (this.$page.isInWechat) {
        wechatService.auth(0,({ openid, unionid }) => {
            if (!!openid && !!unionid) {
              this.unionId = unionid;
              this.openId = openid;
              this.shareConfig();
            }
          },
          false
        );
      }
      if (!this.detail.canTodayBuy) {
        this.minDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      }

      setTimeout(() => {
        this.showTip = false;
      }, 5000);
    },
    shareConfig() {
      // console.log(this.publicData.accountBasic.shareUrl)
      let shareUrl = "";
      let wxShareConfig = {};
      if (this.publicData.accountBasic.shareUrl) {
        wxShareConfig = {
          title: this.detail.title,
          desc: this.detail.insuranceCompany + "-" + this.detail.tags,
          imgUrl: this.detail.poster,
          link: "http://cps1.baojbx.com/detail?id=" + this.$route.query.id + "&c=" + this.publicData.accountBasic.shareUrl,
        };
      } else {
        wxShareConfig = {
          title: this.detail.title,
          desc: this.detail.insuranceCompany + "-" + this.detail.tags,
          imgUrl: this.detail.poster,
          link: location.href,
        };
      }
      console.log("wxShareConfig", wxShareConfig);
      wechatService.jsapi(0, wxShareConfig, ["onMenuShareTimeline","onMenuShareAppMessage",]);
    },
    changeselectPlans(name, title) {
      console.log(name, title);
      this.selectModel.selectPlans = name;
      if(this.detail.insuranceCompanyId == 9){
				  this.detail.plans[name].summarys.forEach((el) => {
				    let regKH = /（(.+?)）/g
				    if(el.name.indexOf("（") != -1){ //判断是否包含括号
							let nameVal = el.name.indexOf("（")
							el.name1 = el.name.substring(0,nameVal)
							let cVal = (el.name).match(regKH);
							if (cVal) {
								for (let i = 0; i < cVal.length; i++) {
									el.nameInfo = cVal[i]
								}
							}
		        }
			    });
			}
      this.summarys = this.detail.plans[name].summarys;
    },
    changeselectTime(index) {
      this.selectModel.selectTime = index;
    },
    changeselectAge(index) {
      this.selectModel.selectAge = index;
    },
    async getDetail() {
        //获取产品信息
        let url = "api/insuranceProduction/getByCode";
        if (this.id.length < 8) {
          url = "api/insuranceProduction/get";
        }
        let res = await this.$http.post(url, { id: this.id == 165296355553 ? 1652915755553 : this.id == 166689250724 ? 1666815750596 : this.id });
        if (res.code == 0) {
          let detail = res.t;
          document.title = "希望保-" + detail.title;
          // console.log("detail",detail)
          // console.log("detail.title",detail.title)
          detail.plans = JSON.parse(detail.plans);
          detail.files = JSON.parse(detail.files);
          if (detail.plans.length > 3) {
            this.showTip = true;
          }
          try {
            detail.summarys = JSON.parse(detail.summarys);

            detail.summarys.forEach((item, index) => {
              item = item.split("：");
              detail.summarys[index] = item;
              console.log(item);
            });
          } catch (error) {}
          console.log("detail.summarys", detail.summarys);
          if(detail.insuranceCompanyId == 9){
            detail.plans[0].summarys.forEach((el) => {
              let regKH = /（(.+?)）/g
              if(el.name.indexOf("（") != -1){ //判断是否包含括号
                let nameVal = el.name.indexOf("（")
                el.name1 = el.name.substring(0,nameVal)
                let cVal = (el.name).match(regKH);
                if (cVal) {
                  for (let i = 0; i < cVal.length; i++) {
                    el.nameInfo = cVal[i]
                  }
                }
              }
            });
          }
          this.detail = detail;
          this.price = this.detail.plans[0].cycle[0].price;
          this.summarys = this.detail.plans[0].summarys;

          let ageArr = [];
          detail.plans[0].cycle.forEach((el) => {
            ageArr.push({
              start: el.startAge,
              end: el.endAge,
            });
          });

          for (let i = ageArr.length; i > 0; i--) {
            for (let j = i - 1; j > -1; j--) {
              if (JSON.stringify(ageArr[i]) === JSON.stringify(ageArr[j])) {
                ageArr.splice(j, 1);
              }
            }
          }
          this.setAges = ageArr;
          let timeArr = [];
          this.detail.plans[this.selectModel.selectPlans].cycle.forEach(
            (el) => {
              // console.log("el",el)
              // console.log(el.startAge , arr[this.selectModel.selectAge].start)
              // console.log(el.endAge , arr[this.selectModel.selectAge].end)
              if (
                el.startAge == ageArr[this.selectModel.selectAge].start &&
                el.endAge == ageArr[this.selectModel.selectAge].end
              ) {
                console.log("el", el);
                timeArr.push(el);
              }
            }
          );
          this.setTimes = timeArr;
          if(this.setTimes.length > 5){
						this.muchDays = true
					}
          this.price = this.setTimes[this.selectModel.selectTime].price;
          document.title = this.detail.title;
          // this.$nextTick(()=>{
          //   let tabs = document.querySelectorAll('#plans-tab .van-tab')
          //   console.log(tabs)
          //   $('#plans-tab .van-tabs__line').css("display","none");
          //   tabs.forEach((el,i)=>{
          //     console.log(            $(el))
          //      el.style.flexDirection= 'column';
          //      el.style.width="100px"
          //      el.style.flexShrink=0;
          //     $(el).html(`
          //       <p style="width:100%;display: flex;justify-content: center;">${this.detail.plans[i].name}</p>
          //       <p style="width:100%;display: flex;justify-content: center;">¥25元</p>
          //     `)
          //   })
          // })
        } else {
          this.$toast.fail(res.msg);
        }

      console.log(res);
    },
    selectMoreDate(value, index) {
      console.log("value",value)
      console.log("index",index)
			this.selectModel.selectTime = index * 1 + 5;
      console.log("this.selectModel.selectTime",this.selectModel.selectTime)
      this.selectPicker = false
		},
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-picker-column__item--selected {
  color: #00d385;
  font-weight: 600;
  font-size: 18px;
}

.detail {
  width: 100%;
  // height: 100%;
  // background: #fff;
  padding-bottom: 50px;
  overflow-x: hidden;
  box-sizing: border-box;
  font-size: 14px;
  .poster {
    width: 100%;
    display: flex;
    img {
      width: 100%;
    }
  }
  .detail-info {
    padding: 15px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .title_little {
      display: flex;
      align-items: center;
      height: 30px;
      .sale_count {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-left: 5px;
      }
    }
    .big-info {
      .item {
        display: flex;
        margin-bottom: 0.03rem;
        .label {
          width: 65px;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          flex-shrink: 0;
          line-height: 20px;
        }
        .item-info {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          .item-btn {
            // width:55px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid rgba(172, 172, 172, 1);
            padding: 0 10px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            margin: 0 3px;
            margin-right: 10px;
            flex-shrink: 0;
            margin-bottom: 5px;
            min-width: 75px;
            box-sizing: border-box;
            &.option-cur {
              background: rgba(0, 211, 133, 0.05);
              border-radius: 4px;
              border: 1px solid rgba(0, 211, 133, 1);
              color: rgba(0, 211, 133, 1);
            }
          }

          .company {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
          }

          .fuhao {
            font-size: 12px;
            color: #ff1010;
          }
          .price {
            color: #ff1010;
            font-size: 20px;
          }
        }
        .summary-info {
          width: 100%;
          padding-top: 5px;
          box-sizing: border-box;
          .item {
            display: flex;
            font-size: 13px;
            width: 100%;
            .title {
              width: 70%;
              color: #888;
              font-size: 13px;
            }
            .price {
              width: 30%;
              color: #000;
              text-align: right;
              font-size: 13px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .select-plan1 {
    width: 100%;
    position: relative;
    .jiantou {
      position: absolute;
      right: 0;
      top: 29px;
      width: 30px;
      // transform: translateY(-50%);
    }
    .title-box {
      height: 40px;
      // padding: 0 15px;
      .price {
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        font-weight: 700;
        color: #666;
        display: flex;
        justify-content: center;
        .fuhao {
        }
      }
      .title {
        display: flex;
        justify-content: center;
      }
    }
  }
  #content2 {
    // padding: 15px;
    box-sizing: border-box;
    padding: 0 15px;
    box-sizing: border-box;
    line-height: 1.8;
    * {
      box-sizing: border-box;
    }
  }
  #content3 {
    padding: 0 15px;
    box-sizing: border-box;
    line-height: 1.8;
  }
  #content4 {
    .img-box {
      padding: 15px;
      box-sizing: border-box;
      padding-bottom: 0px;
      img {
        width: 100%;
      }
    }
    .direct-box {
      padding: 15px;
      box-sizing: border-box;
      p {
        font-size: 13px;
        color: #666;
        line-height: 20px;
        margin: 10px 0;
      }
    }
  }
  .foot-btn {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 2003;
    .left {
      width: 100px;
      flex-shrink: 0;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 211, 133, 1);
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      &:after {
        content: " ";
        position: absolute;
        top: 0;
        width: 1px;
        bottom: 0;
        color: #c7c7c7;
        right: 0;
        border-right: 1px solid #c7c7c7;
        transform: scaleX(0.5);
        height: 60%;
        top: 50%;
        transform: translateY(-50%);
      }
      a {
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .price {
      color: #ff4e33;
      font-weight: 700;
      font-size: 18px;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .right {
      flex: 1;
      background: rgba(0, 211, 133, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      // font-weight: 500;
    }
  }
  .calcurePrice {
    width: 100%;
    padding-bottom: 50px;
    .title {
      border-bottom: 1px solid #f1f1f1;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      position: relative;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .close {
      position: absolute;
      font-size: 14px;
      color: #fb4a41;
      right: 30px;
      top: 20px;
    }
    .plan_start {
      height: 45px;
    }
    .item {
      display: flex;
      margin-bottom: 0.1rem;
      padding-left: 16px;
      box-sizing: border-box;
      .label {
        width: 75px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        flex-shrink: 0;
        line-height: 20px;
      }
      .item-info {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .item-btn {
          // width:55px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(172, 172, 172, 1);
          padding: 0 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin: 0 3px;
          margin-right: 10px;
          flex-shrink: 0;
          margin-bottom: 5px;
          min-width: 75px;
          box-sizing: border-box;
          &.option-cur {
            background: rgba(0, 211, 133, 0.05);
            border-radius: 4px;
            border: 1px solid rgba(0, 211, 133, 1);
            color: rgba(0, 211, 133, 1);
          }
        }

        .company {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
        }

        .fuhao {
          font-size: 12px;
          color: #ff1010;
        }
        .price {
          color: #ff1010;
          font-size: 20px;
        }
      }
      .summary-info {
        width: 100%;
        padding-top: 5px;
        box-sizing: border-box;
        .item {
          display: flex;
          font-size: 13px;
          width: 100%;
          .title {
            width: 70%;
            color: #888;
            font-size: 13px;
          }
          .price {
            width: 30%;
            color: #000;
            text-align: right;
            font-size: 13px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#plans-tab {
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-width: 0 !important;
  }
}
#detail-tabs {
  .van-tabs__line {
    background: #00d385;
  }
}
.select-plan1 {
  .van-tabs__nav {
    background: #f4f4f4;
    padding-left: 5px;
    box-sizing: border-box;
    padding-right: 5px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 70px;
  }
  .van-tabs__nav .van-tab {
    flex-shrink: 0;
    min-width: 30%;
    height: 70px;
    background: #fff;
    padding: 0;
    // margin: 0 10px;
    margin-left: 5px;
    border-radius: 8px 8px 0 0;
  }
  .van-tabs__nav .van-tab--active {
    background-image: linear-gradient(#00e59e, #00d39d);
    // background: rgba(0,0,0,0  );
    .price {
      color: #fff !important;
    }
    .title {
      color: #fff !important;
    }
  }

  .van-tab--active:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: 50%;
    transform: translateY(-50%);
    bottom: -15px;
    border-top: solid 15px black;
    border-right: solid 15px transparent;
    border-left: solid 15px transparent;
    display: none;
  }
  .van-tabs__line {
    width: 0;
    height: 0;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-top: 100px solid red;
    display: none;
  }
  .summary-info {
    padding: 15px;
    .item {
      display: flex;
      font-size: 13px;
      width: 100%;
      margin-bottom: 0.15rem;
      .title {
        width: 70%;
        color: #888;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .price {
        width: 30%;
        color: #000;
        text-align: right;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}
</style>